import {
  DisabledCompanies,
  DisabledObj,
} from '../../../../types/ProductFactory';

export const getDisabledCompanies = (): DisabledCompanies => {
  return {
    arces: {
      insurance_types: ['legal'],
      reason: {
        en: 'Arces rates are not currently available. Please contact Arces for more information.',
        nl: 'De tarieven van Arces zijn momenteel onbeschikbaar, gelieve zich naar Arces te richten voor verdere vragen.',
        fr: "Les tarifs d'Arces sont actuellement indisponibles, veuillez contacter Arces pour de plus amples informations.",
      },
      severity: 'NORMAL',
    },
    optimco: {
      insurance_types: ['home'],
      reason: {
        en: "Due to recent changes to Optimco's product range, the quotes for home are currently not available. Thank you for your understanding.",
        nl: 'Door de recente wijzigingen aan het productgamma van Optimco, zijn de tarieven voor brandverzekeringen momenteel niet beschikbaar. Dank voor je begrip.',
        fr: "En raison de changements récents dans la gamme de produits d'Optimco, les tarifs d'assurance incendie ne sont pas disponibles actuellement. Merci de votre compréhension.",
      },
      severity: 'NORMAL',
    },
    pia: {
      insurance_types: ['car'],
      reason: {
        en: "Private Insurance Assuradeuren's rates are not currently available. Please contact servicedesk@private-insurance.eu for additional questions.",
        nl: 'De tarieven van Private Insurance Assuradeuren zijn momenteel niet beschikbaar. Neem contact op via servicedesk@private-insurance.eu voor aanvullende vragen.',
        fr: 'Les tarifs de Private Insurance Assuradeuren ne sont pas disponibles actuellement. Veuillez contacter servicedesk@private-insurance.eu pour toute question supplémentaire.',
      },
      severity: 'NORMAL',
    },
  };
};

export const isCompanyDisabled = (
  name: string,
  disabledCompanies: DisabledCompanies,
): DisabledObj | undefined => {
  if (disabledCompanies[name]) return disabledCompanies[name];
  return undefined;
};
